export const formControlLabelStyles = (selected: boolean, centered?: boolean) => ({
	position: 'relative',
	display: 'flex',
	flexDirection: 'row',
	justifyContent: centered ? 'center' : 'flex-start',
	alignItems: 'center',
	padding: '0.5rem',
	cursor: 'pointer',
	width: '100%',
	height: '4rem',
	margin: 0,
	border: '0.0625rem',
	borderStyle: 'solid',
	borderRadius: '0.5rem',
	borderColor: selected ? 'secondary.main' : 'neutrals.primary',
	'&:hover': {
		borderColor: 'secondary.main',
	},
	...(selected && {
		outline: '0.0625rem',
		outlineStyle: 'solid',
		outlineColor: 'secondary.main',
	}),
});

export const checkIconStyles = {
	height: '1.5rem',
	width: '1.5rem',
	position: 'absolute',
	color: 'secondary.main',
	top: '0.5rem',
	right: '0.5rem',
};

export const radioStyles = {
	'&:hover': {
		backgroundColor: 'backgrounds.default',
	},
};
